const otpInput = document.getElementById("otp-input");
const otpSubmitBtn = document.getElementById("otp-form-submit-button");
const otpFormErrorMessage = document.getElementById("otp-form-error-message");

otpInput.addEventListener("input", (e) => {
  otpSubmitBtn.disabled = e.target.value.length < 4;
  otpFormErrorMessage.innerText = "";
  otpInput.classList.remove("invalid");
});

const otpValidation = (submit) => {
  if (otpInput.value.length < 4) {
    return otpInput.classList.add("invalid");
  }

  submit();
};

otpSubmitBtn.addEventListener("click", () => {
  otpValidation(checkOtp);
});

const checkOtp = async () => {
  otpSubmitBtn.disabled = true;

  const body = {
    phone: phoneNumberInput.value,
    code: otpInput.value,
  };

  const config = {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-type": "application/json",
    },
  };

  const res = await fetch(
    `${window.location.origin}/apps/yvesrocher/customer/login/attempt`,
    config
  );

  const data = await res.json();
  otpSubmitBtn.disabled = false;

  if (res.ok) {
    login(data.data);
  } else {
    otpFormErrorMessage.innerText = data.data.message;
  }
};

const login = (data) => {
  const { email, password } = data;

  const emailInput = document.getElementById("default-login-email");
  const passwordInput = document.getElementById("default-login-password");
  const form = document.getElementById("customer_login");

  emailInput.value = email;
  passwordInput.value = password;

  form.submit();
};
